import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Icons.css';

const CloseIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  // Responsive SVG size
  const [size, setSize] = React.useState(16);

  React.useEffect(() => {
    function handleResize() {
      setSize(window.innerWidth <= 800 ? 12 : 16);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M8.71005 7.99957L14.8501 1.84957C14.8979 1.80468 14.936 1.75046 14.9621 1.69026C14.9881 1.63006 15.0016 1.56516 15.0016 1.49957C15.0016 1.43397 14.9881 1.36907 14.9621 1.30887C14.936 1.24867 14.8979 1.19446 14.8501 1.14957C14.8052 1.10173 14.7509 1.06361 14.6907 1.03755C14.6306 1.01149 14.5656 0.998047 14.5001 0.998047C14.4345 0.998047 14.3696 1.01149 14.3094 1.03755C14.2492 1.06361 14.1949 1.10173 14.1501 1.14957L8.00005 7.28957L1.85005 1.14957C1.80516 1.10173 1.75095 1.06361 1.69075 1.03755C1.63055 1.01149 1.56565 0.998047 1.50005 0.998047C1.43446 0.998047 1.36956 1.01149 1.30936 1.03755C1.24916 1.06361 1.19494 1.10173 1.15005 1.14957C1.10222 1.19446 1.0641 1.24867 1.03804 1.30887C1.01198 1.36907 0.998535 1.43397 0.998535 1.49957C0.998535 1.56516 1.01198 1.63006 1.03804 1.69026C1.0641 1.75046 1.10222 1.80468 1.15005 1.84957L7.29005 7.99957L1.15005 14.1496C1.10222 14.1945 1.0641 14.2487 1.03804 14.3089C1.01198 14.3691 0.998535 14.434 0.998535 14.4996C0.998535 14.5652 1.01198 14.6301 1.03804 14.6903C1.0641 14.7505 1.10222 14.8047 1.15005 14.8496C1.19494 14.8974 1.24916 14.9355 1.30936 14.9616C1.36956 14.9876 1.43446 15.0011 1.50005 15.0011C1.56565 15.0011 1.63055 14.9876 1.69075 14.9616C1.75095 14.9355 1.80516 14.8974 1.85005 14.8496L8.00005 8.70957L14.1501 14.8496C14.1949 14.8974 14.2492 14.9355 14.3094 14.9616C14.3696 14.9876 14.4345 15.0011 14.5001 15.0011C14.5656 15.0011 14.6306 14.9876 14.6907 14.9616C14.7509 14.9355 14.8052 14.8974 14.8501 14.8496C14.8979 14.8047 14.936 14.7505 14.9621 14.6903C14.9881 14.6301 15.0016 14.5652 15.0016 14.4996C15.0016 14.434 14.9881 14.3691 14.9621 14.3089C14.936 14.2487 14.8979 14.1945 14.8501 14.1496L8.71005 7.99957Z"
        fill="#707275"
      />
    </svg>
  );
};

const { string } = PropTypes;

CloseIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

CloseIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default CloseIcon;
